import { useEffect } from "react";

/**
 * Tiny SEO helper: updates <title>, meta description, canonical, and
 * og:title / og:description for the current route. Used on public pages.
 */
export default function Seo({ title, description, path }) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (title) document.title = title;

    const upsertMeta = (key, value, attr = "name") => {
      if (!value) return;
      let tag = document.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", value);
    };

    upsertMeta("description", description);
    upsertMeta("og:title", title, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:type", "website", "property");
    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);

    if (path) {
      const fullUrl = `https://hg.brimi.in${path}`;
      upsertMeta("og:url", fullUrl, "property");
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", fullUrl);
    }
  }, [title, description, path]);

  return null;
}
